import { render } from "./TransitionVideos.vue?vue&type=template&id=686f245b"
import script from "./TransitionVideos.vue?vue&type=script&lang=js"
export * from "./TransitionVideos.vue?vue&type=script&lang=js"

import "./TransitionVideos.vue?vue&type=style&index=0&id=686f245b&lang=scss"

import exportComponent from "C:\\Users\\chbo\\Documents\\repos\\semco-maritime-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__